import * as types from './types';
import createReducer from '../../createReducer';
import { FETCH_STATE } from 'constants';

const initialState = {
  // Partners list
  partners: [],
  listPagination: {},
  fetchingPartners: FETCH_STATE.UNSENT,
  updatePartnerState: FETCH_STATE.UNSENT,
  // Partner details
  partner: {},
  fetchingPartner: FETCH_STATE.UNSENT,
  // Partners invites
  invites: [],
  invitesPagination: {},
  fetchingInvites: FETCH_STATE.UNSENT,
  invitePartner: FETCH_STATE.UNSENT,
  removeInvite: FETCH_STATE.UNSENT,
};

const partnersReducer = createReducer(initialState)({
  [types.FETCH_PARTNER_BY_ID_REQUEST]: (state) => {
    return {
      ...state,
      partner: {},
      fetchingPartner: FETCH_STATE.LOADING,
    };
  },
  [types.FETCH_PARTNER_BY_ID_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      partner: payload.data,
      fetchingPartner: FETCH_STATE.DONE,
    };
  },
  [types.FETCH_PARTNER_BY_ID_FAILED]: (state, { errors }) => {
    return {
      ...state,
      errors: errors,
      fetchingPartner: FETCH_STATE.ERROR,
    };
  },

  [types.FETCH_PARTNERS_REQUEST]: (state) => {
    return {
      ...state,
      partners: [],
      fetchingPartners: FETCH_STATE.LOADING,
    };
  },
  [types.FETCH_PARTNERS_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      partners: payload.data,
      fetchingPartners: FETCH_STATE.DONE,
      pagination: payload.pagination,
    };
  },
  [types.FETCH_PARTNERS_FAILED]: (state, { errors }) => {
    return {
      ...state,
      errors: errors,
      fetchingPartners: FETCH_STATE.ERROR,
    };
  },

  // INVITE PARTNER
  [types.FETCH_INVITE_PARTNER_REQUEST]: (state) => {
    return {
      ...state,
      invitePartner: FETCH_STATE.LOADING,
    };
  },
  [types.FETCH_INVITE_PARTNER_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      invitePartner: FETCH_STATE.DONE,
    };
  },
  [types.FETCH_INVITE_PARTNER_FAILED]: (state, { errors }) => {
    return {
      ...state,
      invitePartner: FETCH_STATE.ERROR,
      errors,
    };
  },

  // REMOVE PARTNER INVITE
  [types.REMOVE_PARTNER_INVITE_REQUEST]: (state) => {
    return {
      ...state,
      removeInvite: FETCH_STATE.LOADING,
    };
  },
  [types.REMOVE_PARTNER_INVITE_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      removeInvite: FETCH_STATE.DONE,
    };
  },
  [types.REMOVE_PARTNER_INVITE_FAILED]: (state, { errors }) => {
    return {
      ...state,
      removeInvite: FETCH_STATE.ERROR,
      errors,
    };
  },

  // UPDATE PARTNER STATE
  [types.UPDATE_PARTNER_STATE_REQUEST]: (state) => {
    return {
      ...state,
      updatePartnerState: FETCH_STATE.LOADING,
    };
  },
  [types.UPDATE_PARTNER_STATE_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      updatePartnerState: FETCH_STATE.DONE,
      fetchingPartners: FETCH_STATE.UNSENT,
    };
  },
  [types.UPDATE_PARTNER_STATE_FAILED]: (state, { errors }) => {
    return {
      ...state,
      updatePartnerState: FETCH_STATE.ERROR,
      errors,
    };
  },

  // RESET PARTNER
  [types.RESET_PARTNERS_DATA]: (state) => {
    return {
      ...state,
      partners: [],
    };
  },

  // RESET PARTNER
  [types.RESET_PARTNER]: (state) => {
    return {
      ...state,
      fetchingPartners: FETCH_STATE.UNSENT,
      fetchingPartner: FETCH_STATE.UNSENT,
      invitePartner: FETCH_STATE.UNSENT,
      fetchingInvites: FETCH_STATE.UNSENT,
      updatePartnerState: FETCH_STATE.UNSENT,
    };
  },

  // FETCH INVITES
  [types.FETCH_INVITES_REQUEST]: (state) => {
    return {
      ...state,
      invites: [],
      fetchingInvites: FETCH_STATE.LOADING,
    };
  },
  [types.FETCH_INVITES_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      invites: payload.data,
      fetchingInvites: FETCH_STATE.DONE,
      removeInvite: FETCH_STATE.UNSENT,
      invitesPagination: payload.pagination,
    };
  },
  [types.FETCH_INVITES_FAILED]: (state, { errors }) => {
    return {
      ...state,
      errors: errors,
      fetchingInvites: FETCH_STATE.ERROR,
    };
  },
});

export default partnersReducer;
